import React from "react";
import Nav from "../components/layout/Nav";
import Footer from "../components/layout/Footer";
import { site } from "../data/content";

export default function Datenschutz() {
  return (
    <>
      <Nav />
      <main
        className="max-w-[70rem] mx-auto px-6 sm:px-8 lg:px-12 pt-40 pb-24 lg:pb-32"
        data-testid="datenschutz-page"
      >
        <p className="eyebrow">Rechtliches</p>
        <h1 className="mt-4 font-display font-medium text-5xl lg:text-7xl tracking-tighter leading-[1.02]">
          Datenschutzerklärung
        </h1>

        <div className="mt-14 space-y-12 text-brand-primary/85 leading-relaxed max-w-3xl">
          <section>
            <h2 className="text-xl font-medium tracking-tight text-brand-primary">
              1. Verantwortlicher
            </h2>
            <p className="mt-4">
              Verantwortlich für die Datenverarbeitung auf dieser Website ist:
              <br />
              <strong>Metalotsen</strong>, Inhaber {site.owner},{" "}
              {site.address.street}, {site.address.zip} {site.address.city},{" "}
              {site.address.country}. Kontakt:{" "}
              <a href={`mailto:${site.email}`} className="text-brand-accent">
                {site.email}
              </a>
              .
            </p>
          </section>

          <section>
            <h2 className="text-xl font-medium tracking-tight text-brand-primary">
              2. Server-Logfiles
            </h2>
            <p className="mt-4">
              Beim Aufruf unserer Website werden automatisch Informationen
              (Logdateien) durch unseren Hostinganbieter erfasst. Erhoben werden
              IP-Adresse, Datum und Uhrzeit, aufgerufene Seite,
              Referrer-URL, verwendeter Browser sowie Betriebssystem. Die
              Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f
              DSGVO zur Gewährleistung des sicheren Betriebs.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-medium tracking-tight text-brand-primary">
              3. Kontaktformular
            </h2>
            <p className="mt-4">
              Wenn Sie uns über das Kontaktformular Anfragen zukommen lassen,
              werden Ihre Angaben (Name, Unternehmen, E-Mail, Telefon,
              Nachricht) zur Bearbeitung der Anfrage und für den Fall von
              Anschlussfragen bei uns gespeichert. Rechtsgrundlage ist Art. 6
              Abs. 1 lit. b DSGVO (Vertragsanbahnung) sowie Art. 6 Abs. 1 lit.
              a DSGVO auf Basis Ihrer Einwilligung. Die Daten werden gelöscht,
              sobald sie für die Zweckerreichung nicht mehr erforderlich sind.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-medium tracking-tight text-brand-primary">
              4. E-Mail-Versand
            </h2>
            <p className="mt-4">
              Für den Versand von Benachrichtigungen und Antworten auf
              Kontaktanfragen setzen wir einen technischen Dienstleister ein.
              Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b
              und f DSGVO.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-medium tracking-tight text-brand-primary">
              5. Google Maps
            </h2>
            <p className="mt-4">
              Wir binden Kartenmaterial des Dienstes „Google Maps“ (Anbieter:
              Google Ireland Limited) ein. Beim Aufruf der Karte wird eine
              Verbindung zu Servern von Google hergestellt. Google erhält dabei
              Kenntnis Ihrer IP-Adresse. Rechtsgrundlage ist Art. 6 Abs. 1 lit.
              f DSGVO (berechtigtes Interesse an der Auffindbarkeit).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-medium tracking-tight text-brand-primary">
              6. Ihre Rechte
            </h2>
            <p className="mt-4">
              Sie haben jederzeit das Recht auf Auskunft, Berichtigung,
              Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit
              sowie Widerspruch. Zur Ausübung genügt eine formlose Nachricht an{" "}
              <a href={`mailto:${site.email}`} className="text-brand-accent">
                {site.email}
              </a>
              . Zudem steht Ihnen ein Beschwerderecht bei einer
              Datenschutz-Aufsichtsbehörde zu.
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}
